import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

/**
 * Deja pasar si hay sesion. Si no, decide a donde mandar segun el modo de acceso
 * que el API tenga configurado:
 *
 *   entra-id-auto  Se va derecho a Entra ID, sin pantalla de por medio. Si el
 *                  navegador ya trae la sesion de la empresa, la persona no ve
 *                  nada y entra sola.
 *   los demas      Al formulario de siempre.
 *
 * Cuando el modo es automatico pero Entra ID no esta configurado en el API, se cae
 * al formulario: es preferible pedir usuario y contrasena a mandar a la gente a una
 * redireccion que no lleva a ningun lado.
 */
export const authGuard: CanActivateFn = () => {
  const authSvc = inject(AuthService);
  const router = inject(Router);

  if (authSvc.isAuthenticated()) return true;

  return authSvc.getAuthMode().pipe(
    map(modo => {
      if (modo.mode === 'entra-id-auto' && modo.azureConfigured) {
        authSvc.irAEntraId();
        return false;
      }
      return router.createUrlTree(['/login']);
    }),
  );
};
